import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO45 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK004-5.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO45
